<form [formGroup]="form" (ngSubmit)="save()">
  <mat-form-field class="full-width">
    <mat-label>Chat Filter</mat-label>
    <mat-select formControlName="paperFilterSelect" required>
      @for (option of options(); track option) {
        <mat-option
          [disabled]="!option.enabled"
          [value]="option.value"
        >
          {{ option.viewValue }}
          @if (option.count) {
            ({{ option.count }} full-text embedded )
          } @else if (!option.enabled) {
            (No embeddings found, requires screening)
          }
        </mat-option>
      }
    </mat-select>
    @if (form.get('paperFilterSelect')?.hasError('required')) {
      <mat-error>Please choose an FilterType</mat-error>
    }
    @if (showHint()) {
      <mat-hint>This setting is not saved and only valid in this session</mat-hint>
    }
  </mat-form-field>
</form>
